import { useMutation } from "@apollo/client";
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_MEMBER } from "../../../Schema/Member";

export const useDeleteMember = ({ handleClose, setRefetch }) => {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteMember] = useMutation(DELETE_MEMBER, {
    onCompleted: ({ deleteMember }) => {
      setLoading(false);
      if (deleteMember?.isSuccess === true) {
        setAlert(true, "success", deleteMember?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteMember?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = (id) => {
    deleteMember({
      variables: {
        id: id,
      },
    });
  };

  return { handleDelete, loading };
};
